import { render } from "./Partners.vue?vue&type=template&id=5b397ec4&scoped=true"
import script from "./Partners.vue?vue&type=script&lang=js"
export * from "./Partners.vue?vue&type=script&lang=js"

import "./Partners.vue?vue&type=style&index=0&id=5b397ec4&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-5b397ec4"

export default script